// not "use strict" so we can declare global "Promise"

var asap = require('asap');

if (typeof Promise === 'undefined') {
  Promise = require('./lib/core.js')
  require('./lib/es6-extensions.js')
}

require('./polyfill-done.js');



//////////////////
// WEBPACK FOOTER
// ./~/promise/polyfill.js
// module id = 172
// module chunks = 0